import * as React from 'react';
import { VendorViewModel } from '@models/Vendor';
import { VendorInfoComponent } from 'src/vendor/_components/vendor-info/vendor-info.component';
import { LocalForm } from 'react-redux-form';
import { OptionsViewModel } from '@models/common.models';

export interface ReviewStepComponentProperties {
  readonly vendorVM: VendorViewModel;
  readonly saving?: boolean;
  readonly w9StatusOptions?: OptionsViewModel[];
  readonly vendorGroupOptions?: OptionsViewModel[];
  readonly vendorTypeOptions?: OptionsViewModel[];
  readonly vendorStatusOptions?: OptionsViewModel[];
  readonly agreementTypeOptions?: OptionsViewModel[];
  readonly buttonRef: (button: HTMLButtonElement) => void;
  readonly onSaveClick: (model: VendorViewModel) => void;
  readonly jump: (step: number) => void | undefined;
}

export class ReviewStepComponent extends React.Component<ReviewStepComponentProperties> {
  render() {
    return (
      <div>
        <VendorInfoComponent
          vendorVM={this.props.vendorVM}
          w9StatusOptions={this.props.w9StatusOptions}
          vendorGroupOptions={this.props.vendorGroupOptions}
          vendorTypeOptions={this.props.vendorTypeOptions}
          vendorStatusOptions={this.props.vendorStatusOptions}
          agreementTypeOptions={this.props.agreementTypeOptions}
          jump={this.props.jump}
        />
        <LocalForm model="nomodel" hideNativeErrors={true} onSubmit={() => this.props.onSaveClick(this.props.vendorVM)}>
          <div className="row end-xs">
            <div className="col-md">
              <button
                hidden={true}
                disabled={this.props.saving}
                className="btn btn-primary"
                type="submit"
                ref={this.props.buttonRef}
              >
                Save
              </button>
            </div>
          </div>
        </LocalForm>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/steps/review/review-step.component.tsx